/**
 * ╔════════════════════════════════════════════════════════════╗
 * ║  PLANNING CORE PHILOSOPHY                                  ║
 * ╠════════════════════════════════════════════════════════════╣
 * ║  Core Philosophy of Planning: Establishing Clear, Actionable Plans   ║
 * ╚════════════════════════════════════════════════════════════╝
 */

export const PLANNING_CORE = `
# Planning Phase Philosophy

Create actionable, granular plans:
1. Break down complex tasks into atomic units
2. Identify dependencies and execution order
3. Plan for parallel execution where possible
4. Define clear success criteria

Good planning makes execution straightforward.
`;
